/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { colorClassNames } from '../../styles/Colors';
import IconSizeNames from './iconConstants/IconSizeNames';

const IconNotice = (props) => (
  <svg width={IconSizeNames[props.size] || props.size} height={IconSizeNames[props.size] || props.size} viewBox="0 0 24 24" >
    <circle cx="12" cy="12" r="10" style={{ fill: 'none', strokeMiterlimit: 10, strokeWidth: '1.25px' }} className={colorClassNames.stroke(props.color)} />
    <path className={colorClassNames.fill(props.color)} d="M10.91 16.34A1 1 0 0 1 12 15.23a1.05 1.05 0 0 1 .8.29 1.14 1.14 0 0 1 .28.82 1.17 1.17 0 0 1-.28.83 1 1 0 0 1-.8.3 1.09 1.09 0 0 1-.81-.29 1.14 1.14 0 0 1-.28-.84zM12.66 14h-1.28L11 6.53h2z" />
  </svg>
);
IconNotice.propTypes = {
  color: colorClassNames.nameProp,
  size: PropTypes.string,
};

export default IconNotice;
